import { GetUsers, NewUser, EditUser, DeleteUser, SetUserDivide } from '@/apis/user'
import { fixPageAfterDel } from '@/utils/utils'

import { EditUserModal, SetGruopModal } from './components'

import columns from './tableConfig'
import { searchItems } from './searchFormConfig'
let searchCache = {}

export default {
  name: 'User.Search',
  props: {
    defaultGroup: { // 通过路由组件传参，可以匹配编程式导航时传入的 params 的内容
      type: Object,
      default: () => {}
    }
  },
  components: { EditUserModal, SetGruopModal },
  data () {
    return {
      searchItems,
      searching: false,

      columns,
      data: [],
      loading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },

      targetUser: null,

      // 新增、修改用户
      showEditModal: false,

      showSetGruopModal: false
    }
  },
  created () {
    // console.log('--PlatformUser created--', this.defaultGroup)
    this.$nextTick(() => {
      this.$refs.searchForm.handlerSearch()
    })
  },
  computed: {},
  methods: {
    // 查询用户
    async getUsers(page = 1, searchData) {
      try {
        this.loading = true
        // 确定搜索条件
        searchData = searchData || searchCache
        // 缓存搜索条件
        searchCache = searchData
        const { collection: data, pageInfo } = await GetUsers({
          ...searchData,
          page,
          perPage: this.pagination.pageSize
        })
        this.data = data.map(user => {
          return Object.assign(user, {
            key: user.id,
            groups: user.otherInfo
          })
        })

        this.pagination.current = page
        this.pagination.total = pageInfo.total
      } catch (error) { }
      this.loading = this.searching = false
    },
    // 翻页
    handlePageTurn(pagination, filters, sorter) {
      const { current } = pagination
      this.getUsers(current)
    },

    // 新增、修改用户
    handlerOpenEditModal(data) {
      this.targetUser = data || null
      this.showEditModal = true
    },
    // 关闭编辑用户组模态框
    handlerCloseEditModal() {
      this.showEditModal = false
      this.targetUser = null
    },
    // 提交新增\修改用户组信息
    async handleSubmitEdit(data) {
      try {
        if (!this.targetUser) {
          await NewUser({ ...data, loginType: 1 })
          this.getUsers()
        } else {
          await EditUser(data)
          this.getUsers(this.pagination.current)
        }
      } catch (error) { }

      this.handlerCloseEditModal()
    },

    // 删除用户
    handlerDeleteUser(data) {
      const { userName, id } = data
      this.$confirm({
        title: `即将删除用户：${userName}`,
        content: '',
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        confirmLoading: true,
        onOk: () => {
          return DeleteUser({ id }).then(() => {
            this.pagination = fixPageAfterDel(this.pagination)
            this.getUsers(this.pagination.current)
          })
        }
      })
    },

    handleSubmitGroups(data) {
      try {
        data.forEach(async item => {
          await SetUserDivide({
            ...item,
            userId: this.targetUser.id
          })
        })
        this.getUsers(this.pagination.current)
      } catch (error) {}

      this.handlerCloseSetGruopModal()
    },
    handlerOpenSetGroupModal(data) {
      console.log(data)
      this.targetUser = data
      this.showSetGruopModal = true
    },
    handlerCloseSetGruopModal() {
      this.showSetGruopModal = false
      this.targetUser = null
    }
  }
}
